import { render, staticRenderFns } from "./single.vue?vue&type=template&id=05de66ea&scoped=true"
import script from "./single.vue?vue&type=script&lang=js"
export * from "./single.vue?vue&type=script&lang=js"
import style0 from "./single.vue?vue&type=style&index=0&id=05de66ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05de66ea",
  null
  
)

export default component.exports